import { z } from 'zod'

export const GetCreditSafeCompanyAddressSchema = z.object({
  city: z.string().nullish(),
  country: z.string().nullish(),
  postCode: z.string(),
  simpleValue: z.string(),
  street: z.string(),
})

export const GetCreditSafeCompanySchema = z.object({
  country: z.string().nullish(),
  name: z.string(),
  phoneNumbers: z.string().array().nullish(),
  regNo: z.string().nullish(),
})
